// His shelves: the hoard nook at each roost that has one. Sam, 3 Nov:
// "perhaps we give multiple shelves, since he has multiple roosts now".
// Each is a stack of old fruit crates in public/models/hoard.glb, authored
// at world coordinates beside a container, and holds twelve things, his
// finds from the junk heap and the things people gave him alike. The
// town keeps what is on each (sim world/Hoard.js) and the site draws it
// (components/three/world/Hoard.jsx) at the slot empties named here:
// `prefix` and a number from 1, slot 1 being the town's place 0. `nest` is
// the roost's nest entity, `poi` its rest point, `at` where the shelf
// stands as the viewer's (x, z), which is how the town names it to a
// visitor (by the nearest place with a name of its own). A roost with no
// shelf (the tube carriage, for now) is not here, and has none.
//
// Generated by scripts/blender/wants-sync.py from the hoard_nook_root
// empties in Kiwi_world.blend: add or move a shelf there and run that.
//
// Imports nothing.

export const SHELVES = [
  { nest: 'nest_rest', poi: 'rest', at: [-18.75, -2.65], prefix: 'slot_', slots: 12 },
  { nest: 'nest_rest_2', poi: 'rest_2', at: [60.52, 60.77], prefix: 'rest_2_slot_', slots: 12 },
  { nest: 'nest_rest_3', poi: 'rest_3', at: [103.91, 0.84], prefix: 'rest_3_slot_', slots: 12 },
  { nest: 'nest_rest_4', poi: 'rest_4', at: [-13.77, -83.74], prefix: 'rest_4_slot_', slots: 12 },
]

/** The nests that have a shelf, in order. */
export const SHELF_NESTS = SHELVES.map((s) => s.nest)

/** The shelf at this nest, or null. */
export function shelfAt(nest) {
  return SHELVES.find((s) => s.nest === nest) || null
}
